
import sso from '@remote/utils/sso'
import { defineComponent } from 'vue'

export default defineComponent({
  setup () {
    return {}
  },
  async mounted () {
    await sso.init()
  },
})
